import { roleDisplayName, roleLabel } from '@agos/shared'

/**
 * What the sidebar's user pill calls the signed-in person's role - O119, FRONTEND.md §9.753.
 *
 * **The role's own name, falling back to the built-in label**: `roleName` is a custom role's name off `/auth/me`
 * (BACKEND.md §10A.408) and null for a built-in role, which `roleLabel` names - so a person in *Barman* reads
 * *Barman* under their name, and everybody else reads what §9.257 made this print.
 *
 * **The fallback is the base's label, never the key.** A custom role whose name did not arrive - a server from before
 * the deploy, a session cached before the move - prints *Čašník* rather than `custom_3`, which is §9.257's own defect
 * (the pill printed `main_admin` under every name) by a new route. Nobody signed in reads `roleLabel`'s `-`, as before.
 */
export function signedInRoleName(
  systemRole: string | null | undefined,
  roleName: string | null,
): string {
  if (systemRole == null) return roleLabel(systemRole)
  return roleDisplayName({ key: systemRole, name: roleName })
}
